import ProfileLayoutEmployer from "component/employerProfile/profileLayoutEmployer";
import{ memo } from "react";

const EmployerProfilePage = () =>{
    return (
        <ProfileLayoutEmployer/>
    );
}

export default memo(EmployerProfilePage);